<template>
	<div class="modal bg-secondary" style="--bs-bg-opacity: 0.5;" role="dialog" ref="Modal" v-if="ModalShow" :class="modalboxClass" :style="modalboxStyle">
		<div class="modal-dialog modal-dialog-scrollable" :class="[center ? 'modal-dialog-centered' : '', size ? 'modal-' + size : 'modal-lg', sizeIsFull ? 'modal-fullscreen-' + sizeIsFull + '-down' : '', ...modalClass]" role="document">
			<div class="modal-content">
				<div class="modal-header border-0 d-flex justify-content-start py-1" :style="headerStyle" :class="headerClass" v-if="header">
					<slot name="header" :close="close" :ok="ok">
						<!-- <h2>Hello</h2> -->
						<!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
					</slot>
				</div>
				<div class="modal-body py-0" :style="bodyStyle" :class="bodyClass" v-if="body">
					<slot name="body" :close="close" :ok="ok"></slot>
				</div>

				<div class="modal-footer" :style="footerStyle" :class="footerClass" v-if="footer">
					<!-- APPLE手機真的不能padding-bottom太少 -->
					<slot name="footer" :close="close" :ok="ok"> </slot>
				</div>
			</div>
		</div>
		
		
	</div>
</template>

<script lang="ts" setup>
	import { Modal } from "bootstrap";
	const Props = defineProps({
		show: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			default: "",
		},
		center: {
			type: Boolean,
			default: false,
		},
		modalClass: {
			type: Array,
			default: [],
		},
		sizeIsFull: {
			type: String,
			default: "",
		},
		modalboxClass: {
			type: Array,
			default: ["bg-secondary"],
		},
		modalboxStyle: {
			type: Object,
			default() {
				return { "--bs-bg-opacity": 0.5 };
			},
		},
		header: {
			type: Boolean,
			default: true,
		},
		headerStyle: {
			type: Object,
			default() {
				return {};
			},
		},
		headerClass: {
			type: Array,
			default() {
				return [];
			},
		},
		body: {
			type: Boolean,
			default: true,
		},
		bodyStyle: {
			type: Object,
			default() {
				return {};
			},
		},
		bodyClass: {
			type: Array,
			default: [],
		},
		footer: {
			type: Boolean,
			default: true,
		},
		footerStyle: {
			type: Object,
			default() {
				return {};
			},
		},
		footerClass: {
			type: Array,
			default: [],
		},
		backdrop: {
			type: String || Array,
			default: "static",
		},
		focus: {
			type: Boolean,
			default: true,
		},
		keyboard: {
			type: Boolean,
			default: true,
		},
		okfunc: {
			type: Function,
			default: null,
		},
		closefunc: {
			type: Function,
			default: null,
		},
	});
	const Modal = ref(null);
	let DOM: Modal | null = null;
	const emit = defineEmits();
	const { $bootstrap } = useNuxtApp();

	onMounted(() => {});
	watch(
		() => {
			return Props.show;
		},
		(newval, oldval) => {
			if (newval) {
				ModalShow.value = true;
				nextTick(() => {
					if (!DOM) {
						const option = {
							backdrop: Props.backdrop,
							focus: Props.focus,
							keyboard: Props.keyboard,
						};
						DOM = new $bootstrap.Modal(Modal.value, option);
						DOM.show();
					}
					Modal.value.addEventListener("hidden.bs.modal", () => {
						DOM.hide();
						//DOM.dispose();
						DOM = null;
						emit("update:show", false);
						ModalShow.value = false;
					});
				});
			} else {
				if (DOM) {
					DOM.hide();
				}
			}
		}
	);
	const ModalShow = ref(false);
	const close = async () => {
		if (Props.closefunc) {
			await Props.closefunc(Props);
		}
		DOM.hide();
	};
	const ok = async () => {
		if (Props.okfunc) {
			await Props.okfunc(Props);
		}
		DOM.hide();
	};
</script>
